<template>
  <v-container v-if="!!showDialog">
    <v-col
      v-if="userRoles !== 'SERVICEOP'"
      class="d-flex mb-5"
      style="align-items: center; justify-content: center"
    >
      <p
        class="mb-0 mr-3 font-weight-bold"
        style="max-width: 500px"
        ref="textComment"
      ></p>
      <img
        class="col-2 ml-3"
        style="padding: 0"
        ref="logoComment"
        src=""
        alt="there is no logo for this campaign"
      />
      <ul
        v-if="Object.keys(fraudModelWeights).length > 0"
        class="fraudModelWeights"
      >
        <li v-for="(value, key) in filteredFraudModelWeights" :key="key">
          {{ key }}: {{ value }}
        </li>
      </ul>
    </v-col>
    <v-row v-if="userRoles === 'OPERATOR' || userRoles === 'ADMIN'">
      <v-col>
        <v-btn
          class="btn-check d-flex mb-2"
          :disabled="isPending"
          color="blue"
          @click="checkParticipationLimitReached"
        >
          Participation Limit Reached?
        </v-btn>
      </v-col>
      <v-col>
        <v-btn class="mb-3" @click="openReceipt()">
          Open Receipt in a New Tab
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-btn class="mb-3" @click="openReceipt()">
          Open Receipt in a New Tab
        </v-btn>
      </v-col>
    </v-row>
    <v-container v-if="userRoles !== 'SERVICEOP'">
      {{ this.userRoles }}
      <div v-if="fraud">
        <div class="siren" />
        <div class="siren-text">
          Caution! This
          <b>may be</b> fraud
        </div>
      </div>
      <v-col v-if="['AGENT'].includes(userRoles)">
        <v-checkbox
          v-model="editMode"
          class="mx-2"
          label="Edit Receipt Details"
        ></v-checkbox>
      </v-col>
      <v-container fluid>
        <v-col md="12">
          <v-form ref="confirmForm">
            <v-row style="overflow: visible">
              <v-col md="3" class="col-xs-12">
                <date-picker
                  v-if="userRoles === 'OPERATOR' || userRoles === 'ADMIN'"
                  required
                  :dateRule="true"
                  icon="mdi-calendar"
                  label="Select a date"
                  v-model="receiptDateTime"
                  writable
                  :min="isAlwaysCampaign() ? alwaysStartTime : startTimeLimit"
                  :max="isAlwaysCampaign() ? alwaysEndTime : endTimeLimit"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></date-picker>
                <v-text-field
                  v-else
                  :name="Math.random()"
                  v-model="receiptDateTimeFormatted"
                  prepend-icon="mdi-clock-outline"
                  type="date"
                  required
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-text-field>
              </v-col>
              <v-col :md="hasWallet ? '2' : '3'" class="col-xs-12">
                <div class="time-picker-parent">
                  <v-text-field
                    :name="Math.random()"
                    v-model="time"
                    label="Receipt Time"
                    prepend-icon="mdi-clock-outline"
                    format="24hr"
                    type="time"
                    required
                    :rules="[
                      (v) =>
                        timeValidation(v) || 'Please enter the receipt time',
                    ]"
                    :disabled="
                      (inspectMode && !editMode) ||
                      (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                    "
                  ></v-text-field>
                  <!-- <vue-timepicker
                    @open="dropdownStatus = 'opened'"
                    @close="dropdownStatus = 'closed'"
                    v-model="createdAtTime"
                    format="HH:mm"
                    :disabled="(inspectMode && !editMode) "
                  ></vue-timepicker>-->
                </div>
              </v-col>
              <v-col :md="hasWallet ? '2' : '3'" class="col-xs-12">
                <v-text-field
                  :name="Math.random()"
                  prepend-icon="mdi-calculator"
                  v-model="total"
                  type="number"
                  :required="required.total"
                  :rules="[(v) => !!v || 'Please enter the receipt total']"
                  label="Receipt Total"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-text-field>
              </v-col>
              <v-col
                :md="hasWallet ? '2' : '3'"
                class="col-xs-12"
                v-if="hasCashback"
              >
                <v-text-field
                  :name="Math.random()"
                  prepend-icon="mdi-calculator"
                  v-model="paymentAmount"
                  type="number"
                  label="Cashback"
                  v-if="['AGENT', 'AGENTL1'].includes(userRoles)"
                  :disabled="true"
                ></v-text-field>
              </v-col>

              <v-col v-if="hasWallet" md="2" class="col-xs-12">
                <v-text-field
                  :name="Math.random()"
                  prepend-icon="mdi-calculator"
                  v-model="productTotal"
                  type="number"
                  :required="required.total"
                  :rules="[(v) => !!v || 'Please enter the product total']"
                  label="Product Total"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="hasOrderId" md="6" class="col-xs-6">
                <v-text-field
                  :name="Math.random()"
                  prepend-icon="mdi-calculator"
                  v-model="orderId"
                  label="Order ID"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-text-field>
              </v-col>

              <v-col v-if="hasReceiptId" md="3" class="col-xs-6">
                <v-text-field
                  required
                  :name="Math.random()"
                  prepend-icon="mdi-calculator"
                  v-model="receiptId"
                  label="Receipt ID"
                  :rules="[
                    (v) => !!v || 'Please enter the receipt id',
                    (v) => v != 0 || 'Receipt Id cannot be 0',
                  ]"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-text-field>
              </v-col>
              <v-col
                v-if="
                  selectedDashboard &&
                  this.campaign_fk &&
                  selectedDashboard.campaigns &&
                  selectedDashboard.campaigns[this.campaign_fk] &&
                  selectedDashboard.campaigns[this.campaign_fk].hasVatNumber
                "
                md="3"
                class="col-xs-6"
              >
                <v-text-field
                  required
                  :name="Math.random()"
                  prepend-icon="mdi-calculator"
                  v-model="vatNumber"
                  label="VAT Number"
                  :rules="[(v) => !!v || 'Please enter the VAT Number']"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-text-field>
              </v-col>
              <v-col v-if="hasCountrySelection" md="3" class="col-xs-6">
                <v-select
                  :items="hasCountrySelection"
                  :disabled="['AGENTL1'].includes(userRoles)"
                  required
                  label="Country"
                  :rules="[(v) => !!v || 'Please select Country!!']"
                  v-model="country"
                  @change="setCurrentCountry"
                ></v-select>
              </v-col>
              <v-col md="3" class="col-xs-6">
                <v-text-field
                  :name="Math.random()"
                  v-model="createdAtFormatted"
                  label="Created At"
                  prepend-icon="mdi-clock-outline"
                  type="date"
                  required
                  :disabled="true"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="hasRetailer" md="6" class="col-xs-12">
                <v-autocomplete
                  :name="Math.random()"
                  v-model="retailerFk"
                  prepend-icon="mdi-store"
                  :items="campaignRetailers"
                  :item-text="getRetailerName"
                  item-value="id"
                  label="Select Retailer"
                  required
                  :rules="[
                    (v) => !!v || 'Please select a retailer for the receipt',
                  ]"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-autocomplete>
              </v-col>
              <v-col md="6" class="col-xs-12">
                <v-text-field
                  required
                  :name="Math.random()"
                  prepend-icon="mdi-code-tags"
                  v-model="postCode"
                  :label="postCodeLabel"
                  :rules="postCodeRule"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-text-field>
              </v-col>
              <v-col v-if="hasSerialNumber && this.selectedDashboard.campaignId === 'pg-greece'" :md="columnSize" class="col-xs-12">
                  <v-text-field
                    :value="serialNumbersDisplay"
                    :key="Math.random()"
                    prepend-icon="mdi-store"
                    label="Selected Serial Number"
                    :disabled="true"
                  ></v-text-field>
              </v-col>
              <v-col
                v-if="otherSelected && !selectedDashboard.extraRetailerField"
                md="4"
                class="col-xs-4"
              >
                <v-text-field
                  :name="Math.random()"
                  prepend-icon="mdi-store"
                  v-model="location"
                  label="Location"
                  :rules="[
                    (v) => !!v || 'Please select a retailer for the receipt',
                  ]"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-text-field>
              </v-col>
              <v-col v-if="hasClubCode">
                <v-text-field
                  required
                  :name="Math.random()"
                  prepend-icon="mdi-lead-pencil"
                  v-model="clubCode"
                  label="Pampers Club Code"
                  :rules="[(v) => !!v || 'Please enter the Pampers Club Code']"
                  :disabled="inspectMode && !editMode"
                ></v-text-field>
              </v-col>
              <v-col v-if="hasFiscalId">
                <v-text-field
                  required
                  :name="Math.random()"
                  prepend-icon="mdi-lead-pencil"
                  v-model="fiscalId"
                  label="Fiscal ID"
                  :rules="[
                    (v) =>
                      v.length == 0 ||
                      v.length == 12 ||
                      'Length of Fiscal ID should be 12 characters',
                  ]"
                  :disabled="inspectMode && !editMode"
                ></v-text-field>
              </v-col>
              <div v-if="selectedDashboard.extraRetailerField">
                <v-combobox
                  prepend-icon="mdi-store"
                  v-model="ciuNumber"
                  :items="allCiuNumbers"
                  persistent-hint
                  label="CIU/CIF number"
                  :rules="[
                    (v) =>
                      !!v ||
                      'Please select Retailer CIU/CIF Number for the receipt',
                  ]"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-combobox>
                <v-combobox
                  prepend-icon="mdi-store"
                  v-model="retailerName"
                  :items="allRetailerNames"
                  persistent-hint
                  label="Retailer name"
                  :rules="[
                    (v) => !!v || 'Please select Retailer Name for the receipt',
                  ]"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-combobox>
                <v-combobox
                  prepend-icon="mdi-store"
                  v-model="retailerAddress"
                  :items="allRetailerAddresses"
                  persistent-hint
                  label="Retailer address"
                  :rules="[
                    (v) =>
                      !!v || 'Please select Retailer Address for the receipt',
                  ]"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-combobox>
                <v-autocomplete
                  v-model="retailerCity"
                  prepend-icon="mdi-store"
                  :items="$store.state.cities.cities"
                  :item-text="getCityNameFromStore"
                  item-value="id"
                  label="City"
                  :rules="[
                    (v) => !!v || 'Please select a City for the receipt',
                  ]"
                  :disabled="
                    (inspectMode && !editMode) ||
                    (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                  "
                ></v-autocomplete>
                <div class="p-l" style="font-size: 32px">
                  <v-label>Retailer Judet: </v-label
                  ><b
                    ><v-label>{{ retailerJudet }}</v-label></b
                  >
                </div>
              </div>

              <v-col md="1">
                <v-text-field
                  :name="Math.random()"
                  v-if="hasEditableCoupons && !inspectMode"
                  v-model="couponsToCreate"
                  label="Coupons"
                  type="number"
                  error
                />
                <template v-else>
                  <v-text-field
                    :name="Math.random()"
                    v-if="hasEditableCoupons"
                    v-model="couponsToCreate"
                    label="Coupons"
                    type="number"
                    error
                    :disabled="inspectMode && !editMode"
                  />
                </template>
              </v-col>
              <v-col
                v-if="
                  ['OPERATOR', 'AGENT', 'AGENTL1', 'ADMIN'].includes(userRoles)
                "
                sm="12"
                class="col-xs-12"
              >
                <ProductsDropDown
                  v-if="showDialog"
                  ref="productsDropDown"
                  :showDialog="showDialog"
                  :hasGoodWill="hasGoodWill"
                  :retailer="retailerId"
                  :editMode="editMode"
                  :disabled="
                    ['AGENT', 'AGENTL1'].includes(userRoles) && !hasGoodWill
                  "
                  :inspectMode="inspectMode"
                />
                <v-col
                  v-if="
                    selectedDashboard &&
                    this.campaign_fk &&
                    selectedDashboard.campaigns &&
                    selectedDashboard.campaigns[this.campaign_fk] &&
                    selectedDashboard.campaigns[this.campaign_fk]
                      .hasProductImageTable
                  "
                >
                  <v-img
                    :src="
                      selectedDashboard.campaigns[this.campaign_fk]
                        .productImageTableUrl
                    "
                  ></v-img>
                </v-col>
              </v-col>
              <v-row>
                <v-col
                  v-if="
                    selectedDashboard &&
                    this.campaign_fk &&
                    selectedDashboard.campaigns &&
                    selectedDashboard.campaigns[this.campaign_fk] &&
                    selectedDashboard.campaigns[this.campaign_fk].hasInvoice
                  "
                >
                  invoice
                  <v-row style="overflow: visible">
                    <v-col md="3" class="col-xs-12">
                      <date-picker
                        required
                        icon="mdi-calendar"
                        label="Select a invoice date"
                        v-model="invoiceDateTime"
                        writable
                        :min="startTimeLimit"
                        :max="endTimeLimit"
                        :disabled="
                          (inspectMode && !editMode) ||
                          (['AGENT', 'AGENTL1'].includes(userRoles) &&
                            !editMode)
                        "
                      ></date-picker>
                    </v-col>
                    <v-col class="col-xs-12">
                      <div class="time-picker-parent">
                        <v-text-field
                          :name="Math.random()"
                          v-model="invoiceTime"
                          label="Receipt Time"
                          prepend-icon="mdi-clock-outline"
                          format="24hr"
                          type="time"
                          required
                          :rules="[
                            (v) =>
                              timeValidation(v) ||
                              'Please enter the receipt time',
                          ]"
                          :disabled="
                            (inspectMode && !editMode) ||
                            (['AGENT', 'AGENTL1'].includes(userRoles) &&
                              !editMode)
                          "
                        ></v-text-field>
                        <!-- <vue-timepicker
                    @open="dropdownStatus = 'opened'"
                    @close="dropdownStatus = 'closed'"
                    v-model="createdAtTime"
                    format="HH:mm"
                    :disabled="(inspectMode && !editMode) "
                  ></vue-timepicker>-->
                      </div>
                    </v-col>
                    <v-col class="col-xs-12">
                      <v-text-field
                        :name="Math.random()"
                        prepend-icon="mdi-calculator"
                        v-model="invoiceTotal"
                        type="number"
                        :required="required.total"
                        :rules="[
                          (v) => !!v || 'Please enter the invoice total',
                        ]"
                        label="Invoice Total"
                        :disabled="
                          (inspectMode && !editMode) ||
                          (['AGENT', 'AGENTL1'].includes(userRoles) &&
                            !editMode)
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col class="col-xs-12">
                      <v-text-field
                        :name="Math.random()"
                        prepend-icon="mdi-calculator"
                        v-model="invoiceId"
                        type="number"
                        :required="required.total"
                        :rules="[(v) => !!v || 'Please enter the invoice id']"
                        label="Invoice Id"
                        :disabled="
                          (inspectMode && !editMode) ||
                          (['AGENT', 'AGENTL1'].includes(userRoles) &&
                            !editMode)
                        "
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-col v-if="hasRetailer" md="6" class="col-xs-12">
                    <v-autocomplete
                      :name="Math.random()"
                      v-model="manufacturerid"
                      prepend-icon="mdi-store"
                      :items="manufacturer"
                      item-value="id"
                      label="Select Invoice Manufacturer"
                      required
                      :rules="[
                        (v) =>
                          !!v || 'Please select a retailer for the receipt',
                      ]"
                      :disabled="
                        (inspectMode && !editMode) ||
                        (['AGENT', 'AGENTL1'].includes(userRoles) && !editMode)
                      "
                    ></v-autocomplete>
                  </v-col>
                </v-col>
              </v-row>
              <v-expansion-panels
                v-if="['ADMIN', 'AGENT', 'AGENTL1'].includes(userRoles)"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >Receipt Process History</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-data-table
                      v-if="processHistoryHeaders"
                      :headers="processHistoryHeaders"
                      :disable-pagination="true"
                      :hide-default-footer="true"
                      :items="processHistoryParsed"
                      dense
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-expansion-panels
                v-if="['ADMIN', 'AGENT', 'AGENTL1'].includes(userRoles)"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header
                    >Payment History</v-expansion-panel-header
                  >
                  <v-expansion-panel-content>
                    <v-data-table
                      :headers="paymentHistoryHeaders"
                      :disable-pagination="true"
                      :hide-default-footer="true"
                      :items="computedPaymentHistory"
                      dense
                    ></v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
              <v-col class="col-12">
                <v-row v-if="['ADMIN', 'AGENT', 'AGENTL1'].includes(userRoles)">
                  <PrevParticipations />
                </v-row>
              </v-col>
              <v-col v-if="userRoles === 'OPERATOR' || userRoles === 'ADMIN'">
                <v-checkbox
                  v-if="hasFraud"
                  v-model="mayBefraud"
                  label="This may be fraud"
                  :disabled="inspectMode"
                ></v-checkbox>
              </v-col>
              <v-col
                v-if="
                  ['OPERATOR', 'ADMIN', 'AGENT', 'AGENTL1'].includes(userRoles)
                "
              >
                <v-checkbox
                  v-model="isDigital"
                  label="This is Digital"
                ></v-checkbox>
              </v-col>
              <v-col
                sm="12"
                class="col-xs-12"
                v-if="!inspectMode || status == 'Rejected'"
              >
                <v-form
                  v-if="userRoles === 'OPERATOR' || userRoles === 'ADMIN'"
                  ref="rejectReason"
                >
                  <v-autocomplete
                    :name="Math.random()"
                    prepend-icon="mdi-cancel"
                    v-model="rejectReason"
                    :items="rejectReasons"
                    item-value="key"
                    :item-text="getReason"
                    label="Reject Reason"
                    value="Select One"
                    :required="required.rejectReason"
                    :rules="[
                      (v) =>
                        !!v ||
                        'Please select the reject reason for the receipt',
                    ]"
                    :disabled="inspectMode && !editMode"
                  ></v-autocomplete>
                </v-form>
                <v-form
                  v-else-if="['AGENT', 'AGENTL1'].includes(userRoles)"
                  ref="declineReason"
                >
                  <template>
                    <v-btn
                      v-if="
                        selectedDashboard.campaigns[this.campaign_fk]
                          .downloadVoucher
                      "
                      class="mb-4 blue darken-2"
                      @click="downloadVoucher()"
                      color="primary"
                    >
                      Download Voucher PDF
                    </v-btn>
                    <div v-if="selectedDashboard.hasReuploadLink">
                      <div class="title mb-4">Create Reupload Link</div>
                      <v-row>
                        <v-btn
                          v-if="!noReceiptReuploadLink"
                          class="d-flex mb-2 ml-2"
                          :disabled="this.pendingForLink"
                          color="orange darken-4"
                          @click="getReUploadLink('Receipt')"
                          >Receipt Reupload Link Create</v-btn
                        >
                        <v-btn
                          v-if="!noProductReuploadLink"
                          class="d-flex mb-2 ml-2"
                          :disabled="this.pendingForLink"
                          color="orange darken-4"
                          @click="getReUploadLink('Product')"
                          >Product Reupload Link Create</v-btn
                        >
                        <v-btn
                          v-if="hasIbanReuploadLink"
                          class="d-flex mb-2 ml-2"
                          :disabled="this.pendingForLink"
                          color="orange darken-4"
                          @click="getReUploadLink('iban')"
                          >IBAN Reupload Link Create</v-btn
                        >
                        <v-btn
                          v-if="hasProductFELink"
                          class="d-flex mb-2 ml-2"
                          :disabled="this.pendingForLink"
                          color="orange darken-4"
                          @click="getReUploadLink('productFE')"
                          >Product FE Link</v-btn
                        >
                        <v-btn
                          v-if="['AGENTL1'].includes(userRoles)"
                          class="d-flex mb-2 ml-2"
                          :disabled="
                            ['Confirmed'].includes(status) ||
                            this.pendingForLink
                          "
                          color="orange darken-4"
                          @click="getPayoutLink()"
                          >Payout Link Create
                        </v-btn>
                        <v-btn
                          v-if="
                            ['AGENT'].includes(userRoles) &&
                            hasCreateReturnForm &&
                            ['Confirmed'].includes(status)
                          "
                          class="d-flex mb-2 ml-2"
                          :disabled="this.pendingForLink"
                          color="orange darken-4"
                          @click="getReturnFormLink()"
                          >Return Form Link
                        </v-btn>
                      </v-row>
                      <v-checkbox
                        v-model="sendEmail"
                        class="mx-2"
                        label="Send reupload E-mail"
                      ></v-checkbox>
                      <v-row
                        v-if="hasRaffleEmail && ['AGENT'].includes(userRoles)"
                      >
                        <v-col cols="4">
                          <v-text-field
                            :name="Math.random()"
                            v-model="winnerType"
                            label="Winner Type (email case)"
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            :name="Math.random()"
                            v-model="requiredData"
                            label="Required data (iban/address)"
                            outlined
                            dense
                          />
                        </v-col>
                        <v-col cols="4">
                          <v-btn
                            class="d-flex mb-2 ml-2"
                            color="orange"
                            @click="_sendRaffleEmail"
                          >
                            Send Raffle Email (Test)
                          </v-btn>
                        </v-col>
                      </v-row>

                      <div class="col-sm-12" v-if="this.reuploadLink !== ''">
                        <span class="title">Reupload Link:</span>
                        <div
                          class="form-control wizard-form-control d-flex flex-column align-items-center px-20px mb-10px"
                        >
                          <span class="text">{{ this.reuploadLink }}</span>
                          <v-btn
                            class="ml-auto"
                            :color="this.copyColor"
                            style="color: #fff"
                            @click="copyTestingCode()"
                            >Copy</v-btn
                          >
                          <input
                            type="hidden"
                            id="createdReuploadLink"
                            :value="reuploadLink"
                          />
                        </div>
                      </div>
                    </div>
                    <v-col
                      v-if="
                        (status == 'Rejected' || status == 'Confirmed') &&
                        ['AGENT'].includes(userRoles)
                      "
                      sm="10s"
                      class="col-xs-10"
                    >
                      <v-row>
                        <v-select
                          :name="Math.random()"
                          v-model="declineReason"
                          :items="declineReasons"
                          item-value="key"
                          label="Decline Reason"
                          :item-text="getReason"
                          :required="required.declineReason"
                          :rules="[
                            (v) =>
                              !!v ||
                              'Please select the decline reason for the receipt',
                          ]"
                        ></v-select>
                        <v-checkbox
                          v-model="sendAgentEmail"
                          class="mx-2"
                          label="Send E-mail"
                        ></v-checkbox>
                      </v-row>
                      <!-- <v-row>
                        <v-textarea
                          :name="Math.random()"
                          v-if="otherTextBoxEnabled"
                          v-model="customReEvaluation"
                          label="Message"
                          counter
                          maxlength="120"
                          full-width
                          single-line
                        ></v-textarea>
                      </v-row> -->
                      <v-row>
                        <v-btn
                          width="100%"
                          color="primary"
                          @click="sendReceipt('Confirmed')"
                          >Accept</v-btn
                        >
                      </v-row>
                      <v-row>
                        <v-btn
                          class="btn-confirm mt-4"
                          color="red"
                          @click="decline"
                          >Decline</v-btn
                        >
                      </v-row>
                      <v-row>
                        <v-btn
                          v-if="hasGoodWill"
                          class="btn-confirm mt-4"
                          color="green"
                          @click="goodwill"
                          >Accept Goodwill</v-btn
                        >
                      </v-row>
                    </v-col>
                    <v-col
                      v-if="['AGENTL1'].includes(userRoles)"
                      sm="10s"
                      class="col-xs-10"
                    >
                      <v-row>
                        <v-select
                          :name="Math.random()"
                          v-model="reEvaluateReason"
                          :items="reEvaluateReasons"
                          item-value="key"
                          label="ReEvaluate Reason"
                          :item-text="getReason"
                          :required="required.reEvaluateReason"
                          :rules="[
                            (v) =>
                              !!v ||
                              'Please select the re-evaluate reason for the receipt',
                          ]"
                        ></v-select>
                      </v-row>
                      <v-row>
                        <v-textarea
                          :name="Math.random()"
                          v-if="showOtherTextBoxForReEvaluate"
                          v-model="customReEvaluation"
                          label="Enter ReEvaluate Reason"
                          counter
                          maxlength="120"
                          rows="1"
                          full-width
                          single-line
                          :rules="[
                            (v) =>
                              !!v ||
                              'Please enter a re-evaluate reason for the receipt',
                          ]"
                        ></v-textarea>
                      </v-row>
                      <v-row>
                        <v-btn
                          width="100%"
                          color="primary"
                          @click="reEvaluate()"
                          >Re-Evaluate</v-btn
                        >
                      </v-row>
                    </v-col>
                  </template>
                </v-form>
              </v-col>
              <v-col v-if="!inspectMode" sm="12" class="col-xs-12">
                <v-row v-if="userRoles === 'OPERATOR' || userRoles === 'ADMIN'">
                  <v-btn
                    class="btn-reject d-flex mb-2 ml-3"
                    color="red darken-1"
                    :disabled="isPending"
                    @click="sendReceipt('Rejected')"
                    >Reject</v-btn
                  >
                  <v-btn
                    class="btn-confirm d-flex mb-2 ml-3"
                    :disabled="isPending || disableConfirm"
                    color="green"
                    @click="sendReceipt('Confirmed')"
                    >Confirm</v-btn
                  >
                  <v-btn
                    class="btn-confirm d-flex mb-2 ml-2"
                    :disabled="isPending"
                    v-if="hasHoldOn || userRoles === 'ADMIN' || userRoles === 'OPERATOR'"
                    color="orange"
                    @click="holdOnReceipt()"
                    >Hold On</v-btn
                  >
                </v-row>

                <template v-else>
                  <v-col
                    v-if="
                      (status == 'Rejected' || status == 'Confirmed') && isAdmin
                    "
                    sm="12"
                    class="col-xs-12"
                  >
                    <v-row>
                      <v-btn
                        :disabled="!editMode"
                        class="btn-confirm d-flex mb-2 ml-2"
                        color="warning"
                        @click="sendReceipt('Confirmed', true)"
                        >Update and Confirm</v-btn
                      >

                      <v-btn
                        color="danger darken-3"
                        class="ml-5 mr-5"
                        fab
                        small
                        @click="editMode = !editMode"
                      >
                        <v-icon v-if="editMode">mdi-close</v-icon>
                        <v-icon v-else>mdi-pencil</v-icon>
                      </v-btn>
                    </v-row>
                  </v-col>
                </template>
              </v-col>
            </v-row>
            <v-row
                  v-if="selectedDashboard?.hasFraudActions && !(userRoles === 'AGENT' && status === 'Fraud-Check')">
                  <v-btn
                    class="btn-confirm mt-2 ml-3"
                    color="red"
                    @click="setToFraud"
                    >Send to Fraud Review</v-btn
                  >
                </v-row>
          </v-form>
        </v-col>
         <v-col style="margin: 3%;" class="d-flex flex-column align-items-center justify-around"
         v-if="['ADMIN'].includes(userRoles) && selectedDashboard?.hasFraudActions">
          <v-row>
            <h2 style="margin:2% 0; padding: 0" class="text-decoration-underline">Fraud Check Actions</h2>
          </v-row>
          <v-row class="d-flex align-items-center justify-around">
            <v-btn
              class="btn-reject-fraud d-flex mr-5"
                :disabled="isPending"
                color="#4a171b"
                style="background-color: #4a171b; color: white"
                @click="rejectAsFraud"
            >
              Reject as Fraud
            </v-btn>
            <v-btn
              class="btn-reject-fraud d-flex mr-5"
                :disabled="isPending"
                color="black"
                style="background-color: black; color: white"
                @click="rejectAsFraudAndBlacklist"
            >
              Reject as Fraud + Blacklist
            </v-btn>
            <v-btn
              class="btn-not-fraud d-flex mb-2"
              color="#A7C1A8"
              :disabled="isPending"
              @click="setAsNotFraud"
            >
              Set as Not Fraud
            </v-btn>
          </v-row>
        </v-col>
      </v-container>
    </v-container>
    <v-container v-else>
      <ServiceOpDetails @hideviewer="$emit('hideviewer')" />
    </v-container>
  </v-container>
</template>

<script>
import moment from "moment";
import "vue2-timepicker/dist/VueTimepicker.css";
import { mapActions, mapGetters } from "vuex";
import { mapFields } from "../../store/helpers";
import ProductsDropDown from "../ProductsDropDown";
import DatePicker from "../DatePicker.vue";
import PrevParticipations from "../prevParticipations.vue";
import ServiceOpDetails from "./serviceOpDetails.vue";
import axios from "axios";
export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    ProductsDropDown,
    DatePicker,
    PrevParticipations,
    ServiceOpDetails,
  },
  data: () => ({
    paymentHistoryHeaders: [
      { text: "ID", value: "id" },
      { text: "State", value: "state" },
      { text: "Created At", value: "created_at" },
      { text: "Updated At", value: "updated_at" },
    ],
    processHistoryHeaders: [
      { text: "Date", value: "date" },
      { text: "Action", value: "action" },
      { text: "Cause", value: "cause" },
      { text: "Dashboarder ID", value: "dashboarder" },
      { text: "Dashboarder", value: "email" },
    ],
    manufacturer: [
      { text: "Bauknecht", value: "Bauknecht" },
      { text: "Privileg", value: "Privileg" },
      { text: "Whirlpool", value: "Whirlpool" },
      { text: "Indesit", value: "Indesit" },
      { text: "AEG", value: "AEG" },
      { text: "Electrolux", value: "Electrolux" },
      { text: "Candy", value: "Candy" },
      { text: "Hoover", value: "Hoover" },
    ],
    reEvaluateItems: [
      "Wrong Amount",
      "Please Check Date/Time Again",
      "Product is on the receipt",
      "Receipt used only once",
      "Retailer is already on the receipt",
      "Consumer has only participated once",
      // "Goodwill - Accept the receipt",
      "Other",
    ],
    otherSelected: false,
    country: "",
    retailerId: 0,
    hasGoodWill: false,
    invoiceDateTime: "",
    invoiceTime: "",
    invoiceTotal: 0,
    invoiceId: "",
    manufacturerid: "",
    reEvaluationReason: "",
    customReEvaluation: "",
    otherTextBoxEnabled: false,
    showOtherTextBoxForReEvaluate: false,
    required: {
      total: false,
      location: false,
      rejectReason: true,
      declineReason: true,
      reEvaluateReason: true,
      receiptNumber: false,
      retailerSelected: false,
      receiptId: false,
    },
    dateDialog: false,
    productDialog: false,
    dropdownStatus: "closed",
    date: "",
    time: "",
    dateFormatted: "",
    editMode: false,
    sendEmail: false,
    sendAgentEmail: false,
    mayBefraud: false,
    isDigital: false,
    brokenProduct: false,
    openProduct: false,
    pendingForLink: false,
    copyColor: "black",
    parallelCampaignProducts: [],
    parallelCampaignId: "",
    retailerJudet: "N/A",
    winnerType: "",
    requiredData: "",
  }),
  props: {
    inspectMode: {
      required: false,
      type: Boolean,
      default: false,
    },
    showDialog: {
      type: Boolean,
    },
    fraudModelWeights: {
      type: Object,
    },
  },
  mounted() {
    if (moment(this.createdAtDate, "YYYY-MM-DD").isValid()) {
      this.date = moment(this.createdAtDate).format("YYYY-MM-DD");
      this.dateFormatted = moment(this.createdAtDate).format("DD/MM/YYYY");
    } else {
      this.date = "";
      this.dateFormatted = "";
    }
    this.time = moment(this.receiptDateTime).utc().format("HH:mm");
    const found = this.selectedDashboard.hasGoodWill.filter(
      (e) => e == this.campaign_fk
    );
    if (this.showDialog === true && found.length) {
      this.hasGoodWill = true;
    }
    this.country = this.$store.state.currentReceipt.country
      ? this.$store.state.currentReceipt.country
      : "";
    if (this.campaignRetailers && this.campaignRetailers.length == 1) {
      this.retailerFk = this.campaignRetailers[0].id;
    }
    if (this.hasCountrySelection && this.hasCountrySelection.length == 1) {
      this.country = this.hasCountrySelection[0];
      this.$store.state.currentCountry =
        this.$store.state.currentReceipt.country || this.hasCountrySelection[0];
    }
    axios
      .get(
        `${this.selectedDashboard.endPoints.base}/comments?campaignId=${this.campaign_fk}&userToken=${this.userToken}`
      )
      .then((response) => {
        if (response.data.result) {
          this.$refs.logoComment.src = response.data.result.image || "";
          this.$refs.textComment.innerHTML =
            response.data.result.text.replaceAll("\n", "<br>") ||
            "there is no text for this campaign";
        } else {
          this.$refs.logoComment.src = "";
          this.$refs.textComment.innerHTML =
            "there is no text for this campaign";
        }
      })
      .catch((error) => {
        console.log("Error loading comments");
      });
  },
  computed: {
    ...mapGetters([
      "reuploadLink",
      "userToken",
      "allReceipts",
      "selectedReceipt",
      "rejectReasons",
      "declineReasons",
      "reEvaluateReasons",
      "reclaimReasons",
      "locations",
      "isAdmin",
      "selectedDashboard",
      "userRoles",
      "viewedProduct",
      "productImageLength",
      "isTester",
      "processHistory"
    ]),
    ...mapFields([
      "selectedProducts",
      "reClaimed",
      "referenceNumber",
      "createdAt",
      "createdAtTime",
      "retailerFk",
      "status",
      "id",
      "campaignTitle",
      "total",
      "productTotal",
      "rejectReason",
      "declineReason",
      "reEvaluateReason",
      "location",
      "receiptNumber",
      "campaign_fk",
      "receiptId",
      "campaignRetailers",
      "isPending",
      "orderId",
      "hasWallet",
      "vatNumber",
      "productImageURL",
      "couponsToCreate",
      "hasEditableCoupons",
      "processedProducts",
      "selectedCheckbox",
      "paymentAmount",
      "campaignStartDate",
      "campaignEndDate",
      "customerToken",
      "referenceNumber",
      "rejectReason",
      "createdAtDate",
      "receiptDateTime",
      "fraud",
      "processHistory",
      "postCode",
      "retailerCity",
      "ciuNumber",
      "retailerName",
      "retailerAddress",
      "allCiuNumbers",
      "allRetailerNames",
      "allRetailerAddresses",
      "paymentHistory",
      "clubCode",
      "fiscalId",
      "products",
      "rppData"
    ]),

    hasSerialNumber: {
      get() {
        return this.selectedProducts && this.selectedProducts.length > 0 && this.selectedProducts[0].ean;
      }
    },
    serialNumbers: {
      get() {
        return this.selectedProducts && this.selectedProducts.length > 0 && this.selectedProducts[0].ean ?
              this.selectedProducts : "";
      }
    },
    serialNumbersDisplay() {
      return this.serialNumbers
      .map(item => item.ean)
      .filter(ean => ean)
      .join(', ');
    },
    columnSize() {
      if (this.serialNumbers.length <= 2) {
        return 6;
      } else if (this.serialNumbers.length <= 4) {
        return 8;
      } else {
        return 12;
      }
    },
    startTimeLimit() {
      if (this.selectedDashboard.timeLimits) {
        return this.selectedDashboard.timeLimits.start;
      }
      //for campaigns with multi branches like p&g
      if (this.selectedDashboard.campaigns && this.campaign_fk) {
        const campaignSettings =
          this.selectedDashboard.campaigns[this.campaign_fk];
        if (campaignSettings && campaignSettings.timeLimits) {
          return campaignSettings.timeLimits.start;
        }
      }

      return "2020-01-01";
    },
    endTimeLimit() {
      if (this.selectedDashboard.timeLimits) {
        return this.selectedDashboard.timeLimits.end;
      }
      //for campaigns with multi branches like p&g
      if (this.selectedDashboard.campaigns && this.campaign_fk) {
        const campaignSettings =
          this.selectedDashboard.campaigns[this.campaign_fk];
        if (campaignSettings && campaignSettings.timeLimits) {
          return campaignSettings.timeLimits.end;
        }
      }
      return "";
    },
    alwaysStartTime() {
      return moment(this.createdAt).isBefore("2020-12-01")
        ? ""
        : this.startTimeLimit;
    },
    alwaysEndTime() {
      return moment(this.createdAt).isBefore("2020-12-01")
        ? "2020-11-30"
        : this.endTimeLimit;
    },
    computedStartDate() {
      return moment(this.campaignStartDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    },
    computedEndDate() {
      return moment(this.campaignEndDate, "DD-MM-YYYY")
        .add(5, "days")
        .format("YYYY-MM-DD");
    },
    hasOrderId: {
      get() {
        return this.selectedDashboard.hasOrderId;
      },
    },
    hasFraud: {
      get() {
        this.mayBefraud = this.fraud;
        return true;
      },
    },
    hasReceiptId: {
      get() {
        return this.selectedDashboard.hasReceiptId;
      },
    },
    hasRetailer: {
      get() {
        if (this.campaign_fk && this.campaign_fk == "pampers-spar")
          return false;
        return true;
      },
    },
    hasCountrySelection: {
      get() {
        if (
          this.selectedDashboard &&
          this.campaign_fk &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk].countries;
        }
        return this.campaign_fk;
      },
    },
    receiptDateTimeFormatted: {
      get() {
        return moment(new Date(this.receiptDateTime)).format("YYYY-MM-DD");
      },
      set(val) {
        // console.log(val);
        this.receiptDateTime = val;
      },
    },
    hasCashback: {
      get() {
        if (
          this.selectedDashboard &&
          this.campaign_fk &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .removeCashback
            ? !this.selectedDashboard.campaigns[this.campaign_fk].removeCashback
            : true;
        }
        return false;
      },
    },
    cashbackEditable: {
      get() {
        if (
          this.selectedDashboard &&
          this.campaign_fk &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .noCashbackEdit
            ? this.selectedDashboard.campaigns[this.campaign_fk].noCashbackEdit
            : false;
        }
        return false;
      },
    },
    hasHoldOn: {
      get() {
        if (
          this.selectedDashboard &&
          this.campaign_fk &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk].holdOn
            ? this.selectedDashboard.campaigns[this.campaign_fk].holdOn
            : false;
        }
        return false;
      },
    },
    hasIbanReuploadLink: {
      get() {
        if (
          this.selectedDashboard &&
          this.campaign_fk &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .removeIbanReupload
            ? !this.selectedDashboard.campaigns[this.campaign_fk]
                .removeIbanReupload
            : true;
        }
        return false;
      },
    },
    noProductReuploadLink: {
      get() {
        try {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .noProductReuploadLink;
        } catch (e) {
          return false;
        }
      },
    },
    noReceiptReuploadLink: {
      get() {
        try {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .noReceiptReuploadLink;
        } catch (e) {
          return false;
        }
      },
    },
    hasProductFELink: {
      get() {
        if (
          this.selectedDashboard &&
          this.campaign_fk &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .hasProductFELink;
        }
        return false;
      },
    },
    hasCreateReturnForm: {
      get() {
        if (
          this.selectedDashboard &&
          this.campaign_fk &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .hasCreateReturnForm;
        }
        return false;
      },
    },
    postCodeRule: {
      get() {
        if (
          this.selectedDashboard &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .mandatoryPostCode
            ? [(v) => !!v || `Please enter the retailer's postcode`]
            : [];
        }
        return [];
      },
    },
    postCodeLabel: {
      get() {
        if (
          this.selectedDashboard &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk] &&
          this.selectedDashboard.campaigns[this.campaign_fk].postCodeLabel
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .postCodeLabel;
        }
        return "Post Code (postCode)";
      },
    },
    createdAtFormatted: {
      get() {
        return moment(this.createdAt).format("YYYY-MM-DD");
      },
    },
    computedPaymentHistory: {
      get() {
        if (Array.isArray(this.paymentHistory)) {
          return this.paymentHistory;
        } else if (typeof this.paymentHistory === "object") {
          return [this.paymentHistory];
        } else {
          return [];
        }
      },
    },
    reEvaluateReasonText: {
      get() {
        return this.reEvaluateReasons.find(
          (el) => el.key == this.reEvaluateReason
        ).message;
      },
    },
    hasRaffleEmail: {
      get() {
        try {
          return this.selectedDashboard.campaigns[this.campaign_fk]
            .hasRaffleEmail;
        } catch (e) {
          return false;
        }
      },
    },
    hasClubCode: {
      get() {
        return !!this.clubCode;
      },
    },
    hasFiscalId: {
      get() {
        if (
          this.selectedDashboard &&
          this.campaign_fk &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk].hasFiscalId;
        }
        return false;
      },
    },
    disableConfirm() {
      const selectableProducts = this.products.filter((i) => {
        if (!i.retailerId) {
          return true;
        } else if (i.retailerId && i.retailerId === this.retailer) {
          return true;
        } else return false;
      });

      if (
        this.selectedDashboard.campaignId === "pg-ro" &&
        !selectableProducts.length &&
        !this.selectedProducts.length
      )
        return true;
      return false;
    },
    filteredFraudModelWeights() {
      return Object.fromEntries(
        Object.entries(this.fraudModelWeights).filter(
          ([key, value]) => value >= 0.7
        )
      );
    },
    processHistoryParsed() {
      let history = this.processHistory;
      if (!history) return [];
      if (typeof history === "string") {
        try {
          history = JSON.parse(history);
        } catch (e) {
          history = [];
        }
      }
      return Array.isArray(history) ? history : [];
    },
  },
  watch: {
    retailerFk(val) {
      this.retailerId = val;
      if (this.campaignRetailers && this.campaignRetailers.length == 1) {
        this.retailerFk = this.campaignRetailers[0].id;
      }
      const retailer = this.campaignRetailers.find(
        (retailer) => retailer.id === val
      );
      if (retailer) {
        retailer.name = retailer.name.toLowerCase();
        if (retailer.name.includes("other")) {
          return (this.otherSelected = true);
        } else {
          return (this.otherSelected = false);
        }
      } else {
        this.otherSelected = false;
      }
    },
    reEvaluationReason(val) {
      // console.log("val", val);
      if (val === "Other") {
        this.otherTextBoxEnabled = true;
        return;
      }
      this.otherTextBoxEnabled = false;
    },
    date() {
      // console.log("REJECT REASONS", this.rejectReasons);

      this.dateFormatted = this.formatDate(this.date);
    },
    rejectReason(val) {
      console.log("reject reason", val);
      this.rejectReason = val;
    },
    declineReason(val) {
      console.log("decline reason", val);
      this.declineReason = val;
      console.log("history: ", this.processHistory);
    },
    reEvaluateReason(val) {
      if (["productClearlyVisible", "other"].includes(val)) {
        this.showOtherTextBoxForReEvaluate = true;
        return;
      }
      this.showOtherTextBoxForReEvaluate = false;
      this.reEvaluateReason = val;
    },
    receiptNumber(val) {
      this.receiptNumber = val;
    },
    retailerCity(val) {
      const cities = this.$store.state.cities.cities;
      this.retailerJudet = cities.find((elem) => elem.city === val).judet;
    },
    showDialog: {
      // val:{
      handler(val) {
        this.country = this.$store.state.currentReceipt.country
          ? this.$store.state.currentReceipt.country
          : "";
        // console.log("COUNTRY SHOWN", this, this.country);
        this.createdAtDate = moment(this.createdAt).format("YYYY-MM-DD");
        this.createdAtTime = moment(this.createdAt).format("HH:mm");
        this.time = moment(this.receiptDateTime).utc().format("HH:mm");
        if (this.selectedDashboard.hasGoodWill) {
          const found = this.selectedDashboard.hasGoodWill.filter(
            (e) => e == this.campaign_fk
          );
          if (val === true && found.length) {
            this.hasGoodWill = true;
          }
        }
      },
    },
    immediate: true,
    // }
  },
  created() {
    document.addEventListener("focusin", this.focusChanged);
  },
  beforeDestroy() {
    document.removeEventListener("focusin", this.focusChanged);
  },
  methods: {
    ...mapActions([
      "getDashboardData",
      "snackAlert",
      "updateReceiptStatus",
      "saveReceipt",
      "rejectReceipt",
      "confirmReceipt",
      "sendReEvaluation",
      "declineReceipt",
      "confirmGoodwill",
      "holdOn",
      "errorHandler",
      "sendRaffleEmail",
      "changeStatusToFraud",
    ]),
    // Decline replaces reEvaluate at the moment
    decline() {
      // Check if a decline reason is selected or not
      if (!this.$refs.declineReason.validate()) {
        return this.snackAlert({
          message: "Please pick a decline reason ¯\\_(ツ)_/¯",
        });
      }
      const payload = {
        receiptToken: this.id,
        userToken: this.userToken,
        rejectReason: this.declineReason,
        dashboard: this.selectedDashboard,
        sendEmail: this.sendAgentEmail,
        customerToken: this.customerToken,
        campaignId: this.campaign_fk,
        fraud: this.mayBefraud,
        isDigital: this.isDigital,
        brokenProduct: this.brokenProduct,
        country: this.country,
        status,
      };
      // console.log("this.rejectErr: ", this.rejectReasons);
      console.log("payload:::", payload);
      this.declineReceipt(payload);
      this.declineReason = "";
      this.customReEvaluation = "";
      this.$emit("hideviewer");
    },
    reEvaluate() {
      if (!this.$refs.declineReason.validate()) {
        return this.snackAlert({
          message: "Please select a re-evaluate reason¯\\_(ツ)_/¯",
        });
      }
      const payload = {
        receiptToken: this.id,
        userToken: this.userToken,
        reClaimText: this.showOtherTextBoxForReEvaluate
          ? this.customReEvaluation
          : this.reEvaluateReasonText,
        reClaimReason: this.showOtherTextBoxForReEvaluate
          ? this.customReEvaluation
          : this.reEvaluateReason,
        dashboard: this.selectedDashboard,
      };
      console.log("payload:::", payload);
      this.sendReEvaluation(payload);
      this.reEvaluateReason = "";
      this.reEvaluationReason = "";
      this.customReEvaluation = "";
      this.$emit("hideviewer");
    },
    setCurrentCountry() {
      this.$store.state.currentCountry = this.country;
    },
    getColor(status) {
      if (status === "Confirmed") return "success";
      else if (status === "Rejected") return "error";
      else if (status === "Review") return "error";
      else return "blue-grey";
    },
    getRetailerName(item) {
      return `${item.id}) ${item.name}`;
    },
    getReason(item) {
      // console.log("item: ", item, item.message);
      return `[${item.id}] ${item.message}`;
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format("YYYY-MM-DD");
    },
    getCityNameFromStore(item) {
      return item.city;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(date).format("YYYY-MM-DD");
    },
    dateValidation(date, min, max) {
      const isValid = moment(date).isValid();
      // console.log("DATE", "INVALIDE");
      if (
        moment(date).isValid() &&
        moment(min).isValid() &&
        moment(max).isValid()
      ) {
        return false;
      }
      return isValid;
    },
    timeValidation(time) {
      if (time === "") time = "undefined";
      time = `1000-10-10 ${time}`;
      const isValid = moment(time).isValid();
      return isValid;
    },
    datePickerBlur() {
      this.date = this.parseDate(this.dateFormatted);
    },
    focusChanged(event) {
      const el = event.target;
      if (
        document.querySelector(".time-picker-parent") &&
        document.querySelector(".time-picker-parent").contains(el)
      ) {
        document.querySelector(".time-picker .dropdown").style.display =
          "block";
        document.querySelector(".time-picker .dropdown").tabIndex = 0;
      } else {
        if (document.querySelector(".time-picker .dropdown"))
          document.querySelector(".time-picker .dropdown").style.display =
            "none";
      }
      if (el.type !== "button") {
        this.dateDialog = false;
      }
    },
    goodwill() {
      const payload = {
        userToken: this.userToken,
        campaignId: this.campaign_fk,
        products: this.processedProducts,
        selectedCheckbox: this.selectedCheckbox,
        receiptToken: this.id,
        dashboard: this.selectedDashboard,
        identifiedId: this.id,
        identifiedDate: this.createdAtDate,
        identifiedTime: this.createdAtTime,
        date: this.receiptDateTime,
        time: this.time,
        retailer: this.retailerFk,
        location: this.location
          ? this.location
          : JSON.stringify({
              retailer_name: this.retailerName,
              cif_number: this.ciuNumber,
              retailer_address: this.retailerAddress,
              retailer_city: this.retailerCity,
              retailer_judet: this.retailerJudet,
            }),
        receiptId: this.receiptId,
        totalValue: this.total,
        country: this.country,
        postCode: this.postCode,
        vatNumber: this.vatNumber,
        sendEmail: this.sendAgentEmail,
      };
      // console.log(payload);
      this.confirmGoodwill(payload)
        .then((res) => {
          if (res.duplicate) {
            return this.snackAlert({
              message:
                "This is a duplicate receipt! Please reject the receipt.",
            });
          }
          // console.log("inside the then", res);
          this.$refs.productsDropDown.clean();
          this.$eventHub.$emit("updateList"); //Update list On Receipts.vue page
          this.$emit("hideviewer");
        })
        .catch((err) => {
          this.error = err;
          this.snackAlert({
            message: err,
          });
        });
    },
    sendReceipt(status, isUpdate = false, isGoodWill = false) {
      const invoice = {
        invoiceDateTime: this.invoiceDateTime,
        invoiceTime: this.invoiceTime,
        invoiceTotal: this.invoiceTotal,
        invoiceId: this.invoiceId,
        manufacturerid: this.manufacturerid,
      };

      const payload = {
        sessid: this.userToken,
        receipt: {
          id: this.id,
          identifiedId: this.receiptNumber,
          identifiedDate: this.createdAtDate,
          identifiedTime: this.createdAtTime,
          date: this.receiptDateTime,
          time: this.time,
          identifiedRetailer_fk: this.retailerFk,
          location: this.location
            ? this.location
            : JSON.stringify({
                retailer_name: this.retailerName,
                cif_number: this.ciuNumber,
                retailer_address: this.retailerAddress,
                retailer_city: this.retailerCity,
                retailer_judet: this.retailerJudet,
              }),
          totalValue: this.total,
          campaign_fk: this.campaign_fk,
          country: this.country,
          internalNotes: "",
        },
        status: status,
      };

      if (isGoodWill) {
        payload.receipt.isGoodWill;
      }
      if (status === "Confirmed") {
        if (
          this.selectedDashboard &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk].noValidation
        ) {
          this.retailerFk = 1;
          this.receiptId = this.createRandomNumber();
        }
        if (
          !this.$refs.confirmForm.validate() &&
          !this.selectedDashboard.campaigns[this.campaign_fk].noValidation
        ) {
          return this.snackAlert({
            message: "Please fill the required inputs ¯\\_(ツ)_/¯",
          });
        }
        if (this.processedProducts.length === 0) {
          return this.snackAlert({
            message: "Please select at least one product ¯\\_(ツ)_/¯",
          });
        }

        payload.receipt.couponsToCreate = this.couponsToCreate;

        this.hasWallet
          ? (payload.receipt.productTotal = this.productTotal)
          : null;
        if (this.processedProducts.length) {
          const filteredProducts = [];
          this.processedProducts.forEach((product) => {
            if (product.items !== 0) {
              filteredProducts.push(product);
            }
          });
          payload.receipt.processedProducts = this.processedProducts;
        }
      } else if (status === "Rejected") {
        if (!this.$refs.rejectReason.validate()) {
          return this.snackAlert({
            message: "Please pick a reject reason ¯\\_(ツ)_/¯",
          });
        }
        console.log("this.rejectReason ", this.rejectReason);
        payload.receipt.internalNotes = this.rejectReason;
      } else {
        return this.snackAlert({
          message: "Something went wrong. ¯\\_(ツ)_/¯",
        });
      }

      if (!isUpdate) {
        if (status === "Rejected") {
          const rejectPayload = {
            receiptToken: this.id,
            userToken: this.userToken,
            rejectReason: this.rejectReason,
            dashboard: this.selectedDashboard,
            customerToken: this.customerToken,
            campaignId: this.campaign_fk,
            fraud: this.mayBefraud,
            isDigital: this.isDigital,
            brokenProduct: this.brokenProduct,
            country: this.country,
            status,
          };

          this.rejectReceipt(rejectPayload)
            .then((res) => {
              if (res.duplicate) {
                return this.snackAlert({
                  message:
                    "This is a duplicate receipt! Please reject the receipt.",
                });
              }
              this.$refs.productsDropDown.clean();
              this.mayBefraud = false;
              this.isDigital = false;
              this.brokenProduct = false;
              this.$eventHub.$emit("updateList"); //Update list On Receipts.vue page
              this.$emit("hideviewer");
            })
            .catch((err) => {
              this.error = err;
            });
        }

        if (status === "Confirmed") {
          const time = moment(this.time, "HH:mm");
          let now = moment().format("YYYY-MM-DD");
          // Check date
          const startDate = this.isAlwaysCampaign()
            ? this.alwaysStartTime
            : this.startTimeLimit;
          const endDate = this.isAlwaysCampaign()
            ? this.alwaysEndTime
            : this.endTimeLimit;
          if (
            (!moment(this.receiptDateTime).isSameOrBefore(moment(endDate)) ||
            !moment(this.receiptDateTime).isSameOrAfter(moment(startDate)) ||
            !moment(this.receiptDateTime).isSameOrBefore(moment()))
            &&
            !this.isTester
          ) {
            return this.snackAlert({
              message: "Date Selected is Out Of Range of Campaign ¯\\_(ツ)_/¯",
            });
          } else if (
            now.valueOf() <
            moment(this.receiptDateTime).format("YYYY-MM-DD").valueOf()
            && 
            !this.isTester
          ) {
            return this.snackAlert({
              message: "Date Selected is in the Future :D",
            });
          }

          const confirmPayload = {
            receiptToken: this.id,
            userToken: this.userToken,
            rejectReason: this.rejectReason,
            dashboard: this.selectedDashboard,
            customerToken: this.customerToken,
            retailer: this.retailerFk,
            date: moment(this.receiptDateTimeFormatted)
              .utc(true)
              .set({ hour: time.get("hour"), minute: time.get("minute") })
              .format(),
            time: this.time,
            total: this.total,
            products: this.processedProducts,
            selectedCheckbox: this.selectedCheckbox,
            campaignId: this.campaign_fk,
            orderId: this.orderId,
            sendSftp: this.sendSftp,
            fraud: this.mayBefraud,
            isDigital: this.isDigital,
            brokenProduct: this.brokenProduct,
            receiptId: this.receiptId,
            location: this.location
              ? this.location
              : JSON.stringify({
                  retailer_name: this.retailerName,
                  cif_number: this.ciuNumber,
                  retailer_address: this.retailerAddress,
                  retailer_city: this.retailerCity,
                  retailer_judet: this.retailerJudet,
                }),
            country: this.country,
            extra: JSON.stringify(invoice),
            status,
            vatNumber: this.vatNumber,
            postCode: this.postCode,
            clubCode: this.clubCode,
            fiscalId: this.fiscalId,
            rppData: this.rppData
          };
          if (this.userRoles === "AGENT") {
            confirmPayload["sendEmail"] = this.sendAgentEmail;
            console.log(confirmPayload);
          }
          if (
            this.productImageURL &&
            this.viewedProduct.length !== this.productImageLength &&
            !this.selectedDashboard.campaigns[this.campaign_fk].hasInvoice
          )
            return this.snackAlert({
              message: "You have to see product first ¯\\_(ツ)_/¯",
            });

          if (
            this.selectedDashboard &&
            this.selectedDashboard.campaigns &&
            this.selectedDashboard.campaigns[this.campaign_fk].hasVatMetro &&
            this.selectedCheckbox &&
            this.selectedCheckbox.vatMetro &&
            !this.selectedCheckbox.vatMetro.value
          ) {
            return this.snackAlert({
              message: "VAT is mandatory for this campaign.",
            });
          }
          this.confirmReceipt(confirmPayload)
            .then((res) => {
              if (res.duplicate) {
                return this.snackAlert({
                  message:
                    "This is a duplicate receipt! Please reject the receipt.",
                });
              }
              this.mayBefraud = false;
              this.isDigital = false;
              this.brokenProduct = false;
              this.$refs.productsDropDown.clean();
              this.$eventHub.$emit("updateList"); //Update list On Receipts.vue page
              this.$emit("hideviewer");
            })
            .catch((err) => {
              this.error = err;
              this.snackAlert({
                message: err,
              });
            });
        }
      } else {
        this.updateReceiptStatus(payload)
          .then((res) => {
            if (res.duplicate) {
              this.error = "Receipt is a duplicate and cannot be confirmed.";
              return;
            }
            this.$refs.productsDropDown.clean();
            this.$emit("hideviewer");
          })
          .catch((err) => {
            this.error = err;
          });
      }
    },
    isAlwaysCampaign() {
      return this.campaign_fk === "always-testwoche";
    },
    copyTestingCode() {
      let testingCodeToCopy = document.querySelector("#createdReuploadLink");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        this.copyColor = "green";
      } catch (err) {
        this.copyColor = "red";
        alert("Oops, unable to copy");
      }
      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
    getReUploadLink(type) {
      this.copyColor = "black";
      this.pendingForLink = true;
      axios({
        method: "post",
        url: `${this.selectedDashboard.endPoints.base}/createReuploadLink`,
        data: {
          userToken: this.userToken,
          receiptToken: this.id,
          campaignId: this.campaign_fk,
          type: type,
          sendEmail: this.sendEmail,
          customerToken: this.customerToken,
        },
      })
        .then((response) => {
          if (response.data.response) {
            this.pendingForLink = false;
            this.$store.commit("setReuploadLink", response.data.reuploadLink);
          } else {
            this.errorHandler(response.data.message || response.data.error);
          }
        })
        .catch((er) => {
          this.pendingForLink = false;
          this.errorHandler(er.response);
        });
    },
    getPayoutLink() {
      this.copyColor = "black";
      this.pendingForLink = true;
      axios({
        method: "post",
        url: `${this.selectedDashboard.endPoints.base}/createPayoutLink`,
        data: {
          userToken: this.userToken,
          receiptToken: this.id,
          campaignId: this.campaign_fk,
          sendEmail: this.sendEmail,
          customerToken: this.customerToken,
        },
      })
        .then((response) => {
          if (response.data.response) {
            this.pendingForLink = false;
            this.$store.commit("setPayoutLink", response.data.payoutLink);
          } else {
            this.errorHandler(response.data.message || response.data.error);
          }
        })
        .catch((er) => {
          this.pendingForLink = false;
          this.errorHandler(
            er.response.data.message || er.response.data.error || er.response
          );
        });
    },
    getReturnFormLink() {
      this.copyColor = "black";
      this.pendingForLink = true;
      axios({
        method: "post",
        url: `${this.selectedDashboard.endPoints.base}/createReturnForm`,
        data: {
          userToken: this.userToken,
          receiptToken: this.id,
          campaignId: this.campaign_fk,
          customerToken: this.customerToken,
        },
      })
        .then((response) => {
          if (response.data.response) {
            this.pendingForLink = false;
            this.$store.commit("setReuploadLink", response.data.link);
          } else {
            this.errorHandler(response.data.message || response.data.error);
          }
        })
        .catch((er) => {
          this.pendingForLink = false;
          this.errorHandler(
            er.response.data.message || er.response.data.error || er.response
          );
        });
    },
    createRandomNumber() {
      let text = "";
      const possible = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789";

      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
    holdOnReceipt() {
      const payload = {
        userToken: this.userToken,
        receiptToken: this.id,
        campaignId: this.campaign_fk,
        dashboard: this.selectedDashboard,
      };
      this.holdOn(payload).then((res) => {
        this.$emit("hideviewer");
      });
    },
    checkParticipationLimitReached() {
      axios({
        method: "post",
        url: `${this.selectedDashboard.endPoints.base}/checkParticipationLimitOnAReceipt`,
        data: {
          userToken: this.userToken,
          receiptToken: this.id,
          campaignId: this.campaign_fk,
        },
      })
        .then((response) => {
          if (response.data.response) {
            return this.snackAlert({
              message: "User can participate to the campaign",
              type: "success",
            });
          } else {
            return this.snackAlert({
              message: response.data.error,
            });
          }
        })
        .catch((er) => {
          this.errorHandler(er.response);
        });
    },
    downloadVoucher() {
      const formData = {
        userToken: this.userToken,
        campaignId: this.campaign_fk,
        referenceNumber: this.referenceNumber,
      };
      axios
        .post(
          `${this.selectedDashboard.endPoints.base}/download-voucher`,
          formData,
          { responseType: "blob" }
        )
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `voucher-${this.referenceNumber}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        });
    },
    _sendRaffleEmail() {
      const payload = {
        dashboard: this.selectedDashboard,
        userToken: this.userToken,
        campaignId: this.campaign_fk,
        receiptToken: this.id,
        winnerType: this.winnerType,
        requiredData: this.requiredData,
      };
      this.sendRaffleEmail(payload)
        .then((res) => {
          return this.snackAlert({
            message: "Raffle email sent!",
            type: "success",
          });
        })
        .catch((err) => {
          this.snackAlert({
            message: err.error.message,
          });
        });
    },
    openReceipt() {
      let url = ''
      if (this.$store.state.currentReceipt.receiptImageURL.includes('?')) {
        url = this.$store.state.currentReceipt.receiptImageURL
      } else {
        const param = '?v=' + Math.round(Math.random() * 10000)
        url = this.$store.state.currentReceipt.receiptImageURL + param
      }
      window.open(url, "_blank");
    },
    setToFraud() {
      const payload = {
        dashboard: this.selectedDashboard,
        campaignId: this.campaign_fk,
        receiptToken: this.id,
        referenceNumber: this.referenceNumber,
      };
      this.changeStatusToFraud(payload)
        .then((res) => {
          if (res.response === true) {
            this.snackAlert({
              message: "Receipt has been send to FRAUD REVIEW!",
              type: "success",
            });
          this.$refs.productsDropDown.clean();
          this.$emit("hideviewer");
          } else {
            this.snackAlert({
              message: res.error || "An error occurred",
              type: "error"
            });
          }
        })
        .catch((err) => {
          console.error('setToFraud error:', err);
          let errorMessage = "An unexpected error occurred";
          
          if (err.response && err.response.data) {
            errorMessage = err.response.data.error || err.response.data.message || errorMessage;
          } else if (err.error) {
            errorMessage = err.error.message || err.error || errorMessage;
          } else if (err.message) {
            errorMessage = err.message;
          } else if (typeof err === 'string') {
            errorMessage = err;
          }
          
          this.snackAlert({
            message: errorMessage,
            type: "error"
          });
        });
    },
    rejectAsFraud() {
      axios.post(
        `${this.selectedDashboard.endPoints.base}/changeFraudResult`,
        {
          userToken: this.userToken,
          receiptToken: this.id,
          campaignId: this.campaign_fk,
          referenceNumber: this.referenceNumber,
          fraudAction: "POSITIVE",
        }
      )
      .then((res) => {
        if (res.data.response) {
          const payload = {
            userToken: this.userToken,
            dashboard: this.selectedDashboard,
            rejectReason: "fraud",
            receiptToken: this.id,
            customerToken: this.customerToken,
            campaignId: this.campaign_fk,
            fraud: true,
            brokenProduct: this.brokenProduct,
            isDigital: this.isDigital,
          };
          this.rejectReceipt(payload)
            .then(() => {
              this.snackAlert({
                message: "Receipt rejected as fraud and fraud result saved!",
                type: "success",
              });
              this.$emit("hideviewer");
            })
            .catch((err) => {
              this.snackAlert({
                message: err,
              });
              this.$emit("hideviewer");
            });
        } else {
          this.snackAlert({
            message: res.data.error || "Fraud result could not be saved.",
            type: "error",
          });
          this.$emit("hideviewer");
        }
      })
      .catch((err) => {
        this.snackAlert({
          message: err?.response?.data?.error || err.message || "Fraud result error",
          type: "error",
        });
        this.$emit("hideviewer");
      });
    },
    rejectAsFraudAndBlacklist() {
      axios.post(
        `${this.selectedDashboard.endPoints.base}/changeFraudResult`,
        {
          userToken: this.userToken,
          receiptToken: this.id,
          campaignId: this.campaign_fk,
          referenceNumber: this.referenceNumber,
          fraudAction: "POSITIVE_BLACKLIST",
        }
      )
      .then((res) => {
        if (res.data.response) {
          const payload = {
            userToken: this.userToken,
            dashboard: this.selectedDashboard,
            rejectReason: "fraud",
            receiptToken: this.id,
            customerToken: this.customerToken,
            campaignId: this.campaign_fk,
            fraud: true,
            brokenProduct: this.brokenProduct,
            isDigital: this.isDigital,
          };
          this.rejectReceipt(payload)
            .then(() => {
              this.snackAlert({
                message: "Receipt rejected as fraud, user blacklisted and fraud result saved!",
                type: "success",
              });
              this.$emit("hideviewer");
            })
            .catch((err) => {
              this.snackAlert({
                message: err,
              });
              this.$emit("hideviewer");
            });
        } else {
          this.snackAlert({
            message: res.data.error || "Fraud result could not be saved.",
            type: "error",
          });
          this.$emit("hideviewer");
        }
      })
      .catch((err) => {
        this.snackAlert({
          message: err?.response?.data?.error || err.message || "Fraud result error",
          type: "error",
        });
        this.$emit("hideviewer");
      });
    },
    setAsNotFraud() {
      axios.post(
        `${this.selectedDashboard.endPoints.base}/changeFraudResult`,
        {
          userToken: this.userToken,
          receiptToken: this.id,
          campaignId: this.campaign_fk,
          referenceNumber: this.referenceNumber,
          fraudAction: "NEGATIVE",
        }
      )
      .then((res) => {
        if (res.data.response) {
          this.snackAlert({
            message: "Receipt marked as NOT FRAUD and status set to Pre-Confirmed!",
            type: "success",
          });
        } else {
          this.snackAlert({
            message: res.data.error || "Could not set as Not Fraud.",
            type: "error",
          });
        }
        this.$emit("hideviewer");
      })
      .catch((err) => {
        this.snackAlert({
          message: err?.response?.data?.error || err.message || "Error while setting as Not Fraud.",
          type: "error",
        });
        this.$emit("hideviewer");
      });
    },
},
};
</script>
<style scoped>
.siren {
  height: 75px;
  width: 75px;
  background-image: url("../../assets/siren.png");
  background-size: contain;
  position: absolute;
  margin-top: -50px;
  margin-left: 20px;
}
.siren-text {
  position: absolute;
  top: 27px;
  color: #e57373;
  left: 42px;
}
</style>
<style>
.campaign-title,
.campaign-description,
.campaign-details {
  margin-bottom: 1rem;
}
.time-picker-parent {
  position: relative;
}
.time-picker-parent .v-text-field__details {
  display: none;
}
.time-picker input,
.time-picker .clear-btn {
  display: none;
}
.time-picker {
  position: absolute;
}
.time-picker .dropdown {
  position: absolute;
  top: 0px;
  left: 2rem;
}
.btn-reject,
.btn-confirm {
  flex: 1;
}
.btn-check {
  flex: 1;
  max-width: fit-content;
  margin: 0 auto;
}
@media (max-width: 960px) {
  .col-xs-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
  }
}
.v-list img {
  height: 48px;
}
.fraudModelWeights {
  list-style: none;
}
</style>
